import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Container,
  Tabs,
  Tab,
  Box,
  TextField,
  MenuItem,
  Button,
  Modal,
  Dialog,
  Typography,
  Divider,
} from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Moment from "moment";
import { debounce } from "lodash";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useNavigate } from "react-router-dom";
import DialogContent from '@mui/material/DialogContent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const InsuranceForm = ({
  type,
  patientId,
  firstName,
  lastName,
  dob,
  gender,
  onCancel,
}) => {
  const { register, handleSubmit, setValue, getValues, control } = useForm({
    mode: "onBlur",
    defaultValues: {
      id: 0,
      insuranceId: 0,
      patientId: 0,
      planName: "",
      payerid: "",
      groupNumber: "",
      policyNumber: "",
      type: type.toLowerCase(),
      copay: 0,
      deductible: 0,
      relation: "",
      memberId: "",
      startDate: "",
      endDate: "",
    },
  });
  const location = useLocation();
  const patientIds = location.state?.patientId || null;
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [insuranceData, setInsuranceData] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [insuranceId, setInsuranceId] = useState(0);
  const [payerId, setPayerId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [eligibilityOpen, setEligibilityOpen] = useState(false);
const [isDialogOpenResp, setDialogOpenResp] = useState(false);
  const token = localStorage.getItem("Thyra_Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
    "Content-Type": "application/json",
  };

  console.log("Uzair patientId", patientIds);
  useEffect(() => {
    if (patientIds > 0) {
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/PatientInsurance/getPatientInsuranceByid?patientid=${patientIds}&type=${type.toLowerCase()}`,
          { headers }
        )
        .then((response) => {
          const data = response;
          setValue("id", data.id || 0);
          setValue("insuranceId", data.insuranceId || 0);
          setValue("planName", data.planName || "");
          setValue("payerId", data.payerId || "");
          setValue("groupNumber", data.groupNumber || "");
          setValue("policyNumber", data.policyNumber || "");
          setValue("type", data.type || type.toLowerCase());
          setValue("copay", data.copay || 0);
          setValue("deductible", data.deductible || 0);
          setValue("relation", data.relation || "");
          setValue("memberId", data.memberId || "");
          setStartDate(
            data.startDate ? Moment(data.startDate).format("YYYY-MM-DD") : ""
          );
          setEndDate(
            data.endDate ? Moment(data.endDate).format("YYYY-MM-DD") : ""
          );
          setInsuranceId(data.insuranceId || 0);
          setPayerId(data.payerId || "");
        })
        .catch((error) => {
          console.error("Error fetching insurance data:", error);
        });
    }
  }, [patientIds, type, setValue]);

  const handleInsuranceSearch = useCallback(
    debounce(async (value) => {
      if (value.length > 0) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?name=${value}`,
            { headers }
          );
          const data = Array.isArray(response) ? response : [];

          setInsuranceData(data);
          setShowSearchResults(true);
        } catch (error) {
          console.error("Error searching insurance:", error);
          setInsuranceData([]);
          setShowSearchResults(false);
        }
      } else {
        setInsuranceData([]);
        setShowSearchResults(false);
      }
    }, 300),
    [headers]
  );

  const handleSelectInsurance = (insurance) => {
    setValue("planName", insurance.name);
    setValue("insuranceId", insurance.id);
    setValue("payerid", insurance.name); // Using name to match screenshot; use insurance.payerid if needed
    setInsuranceId(insurance.id);
    setPayerId(insurance.name); // Using name to match screenshot; use insurance.payerid if needed
    setSearchText(insurance.name);
    setShowSearchResults(false);
  };

  const onSubmit = async (data) => {
    setSubmitting(true);
    const postData = {
      ...data,
      insuranceId,
      patientId: patientIds,
      payerid: payerId,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientInsurance/AddPatientInsurance`,
        postData,
        { headers }
      );
      if (response.data.id) {
        setDialogOpen(true);
        setTimeout(() => {
          navigate('/Procedure');
          setDialogOpenResp(false);
        }, 1000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };
  const handleCancelPage = () => {
    navigate("/Patient");
  };
  return (
    <Box style={{ padding: "16px" }}>
      <Dialog
             open={isDialogOpenResp}
             onClose={() => setDialogOpenResp(false)}
             PaperProps={{
               style: {
                 marginRight: '5px',
                 float: 'right',
                 marginTop: '5px',
                 color: 'red',
                 cursor: 'pointer',
               },
             }}
           >
             <div
               style={{
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'center',
                 borderRadius: '8px',
                 width: '500px',
               }}
             >
               <CheckCircleIcon style={{ fontSize: '100px', color: 'green' }} />
               <h5
                 style={{
                   textAlign: 'center',
                   fontSize: '16px',
                   fontWeight: 'normal',
                   color: '#444444',
                 }}
               >
                 Insurance {patientIds > 0 ? 'updated' : 'added'} successfully
               </h5>
               <DialogContent />
             </div>
           </Dialog>

      <Modal open={eligibilityOpen} onClose={() => setEligibilityOpen(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 900,
            backgroundColor: "white",
            border: "2px solid #000",
            boxShadow: "0 3px 7px rgba(0,0,0,0.3)",
            padding: "16px",
            borderRadius: "10px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6">Eligibility Check</Typography>
          <Box>
            <Typography>Patient ID: {patientId}</Typography>
            <Typography>First Name: {firstName}</Typography>
            <Typography>Last Name: {lastName}</Typography>
            <Typography>DOB: {dob}</Typography>
            <Typography>Gender: {gender}</Typography>
            <Typography>Group Number: {getValues("groupNumber")}</Typography>
            <Typography>Policy Number: {getValues("policyNumber")}</Typography>
            <Typography>Member ID: {getValues("memberId")}</Typography>
            <Typography>Relation: {getValues("relation")}</Typography>
          </Box>
          <Button
            variant="contained"
            onClick={() => setEligibilityOpen(false)}
            style={{
              marginTop: "16px",
              backgroundColor: "#000",
              color: "#fff",
            }}
          >
            Close
          </Button>
        </Box>
      </Modal>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography component="label" style={{ color: "#67748e" }}>
              Insurance
            </Typography>
            <Controller
              name="planName"
              control={control}
              render={({ field }) => (
                <TextField
                  style={{ marginTop: "10px" }}
                  size="small"
                  fullWidth
                  variant="outlined" // Add outlined variant to match screenshot
                  placeholder="Enter Insurance Name" // Add placeholder
                  InputProps={{
                    style: { height: "40px" }, // Match height with other fields
                  }}
                  {...field}
                  onChange={(e) => {
                    field.onChange(e); // Update form value
                    setSearchText(e.target.value);
                    handleInsuranceSearch(e.target.value);
                  }}
                  onBlur={() => {
                    // Delay hiding dropdown to allow clicking items
                    setTimeout(() => setShowSearchResults(false), 200);
                  }}
                />
              )}
            />
            {showSearchResults && insuranceData && (
              <div
                style={{
                  height: 150,
                  overflowY: "scroll",
                  padding: "14px 16px",
                  fontSize: "0.875rem",
                  color: "#67748e",
                  borderRadius: "5px",
                  background: "white",
                  textAlign: "left",
                  position: "absolute",
                  zIndex: "99",
                  width: "50%",
                  border: "1px solid #DCDBDD",
                }}
              >
                {insuranceData.length > 0 ? (
                  insuranceData.map((s, index) => {
                    const pat = s.name || "";
                    const patLower = pat.toLowerCase();
                    const searchTextLower = searchText.toLowerCase();
                    const i = patLower.indexOf(searchTextLower);
                    const p1 = i >= 0 ? pat.substring(0, i) : pat;
                    const p =
                      i >= 0 ? pat.substring(i, i + searchText.length) : "";
                    const p2 =
                      i >= 0 ? pat.substring(i + searchText.length) : "";
                    return (
                      <p
                        key={index}
                        style={{ cursor: "pointer", margin: "5px 0" }}
                        onMouseDown={() => handleSelectInsurance(s)}
                      >
                        <span>{p1}</span>
                        {p && (
                          <span style={{ backgroundColor: "yellow" }}>{p}</span>
                        )}
                        <span>{p2}</span>
                        <Divider />
                      </p>
                    );
                  })
                ) : (
                  <Typography>No Record found</Typography>
                )}
              </div>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography>Payer ID</Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter your Payer ID"
              variant="outlined"
              style={{marginTop:'10px'}}
              InputProps={{
                style: { height: "40px" },
                readOnly: true,
                value: payerId,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>Group Number</Typography>
            <TextField
              fullWidth
              style={{marginTop:'10px'}}
              size="small"
              placeholder="Enter your Group ID"
              variant="outlined"
              InputProps={{ style: { height: "40px" } }}
              {...register("groupNumber")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography>Relation</Typography>
            <Controller
              name="relation"
              control={control}
              render={({ field }) => (
                <TextField
                  fullWidth
                  select
                  style={{marginTop:'10px'}}
                  size="small"
                  variant="outlined"
                  {...field}
                  SelectProps={{ style: { height: "40px" } }}
                  onChange={(e) => field.onChange(e.target.value)} // Update form state
                  value={field.value || ""} // Controlled by react-hook-form
                >
                  <MenuItem value="Father">Father</MenuItem>
                  <MenuItem value="Mother">Mother</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </TextField>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography>Member ID</Typography>
            <TextField
              fullWidth
              size="small"
              style={{marginTop:'10px'}}
              placeholder="Enter your Member ID"
              variant="outlined"
              InputProps={{ style: { height: "40px" } }}
              {...register("memberId")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>Policy Number</Typography>
            <TextField
              fullWidth
              size="small"
              style={{marginTop:'10px'}}
              placeholder="Enter your Policy Number"
              variant="outlined"
              InputProps={{ style: { height: "40px" } }}
              {...register("policyNumber")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>Start Date</Typography>
            <TextField
              fullWidth
              size="small"
              style={{marginTop:'10px'}}
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{ style: { height: "40px" } }}
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                setValue("startDate", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>End Date</Typography>
            <TextField
              fullWidth
              type="date"
              size="small"
              style={{marginTop:'10px'}}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{ style: { height: "40px" } }}
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setValue("endDate", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>Deductible</Typography>
            <TextField
              fullWidth
              size="small"
              style={{marginTop:'10px'}}
              placeholder="Enter your Deductible number"
              type="number"
              variant="outlined"
              InputProps={{ style: { height: "40px" } }}
              {...register("deductible")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>Copay</Typography>
            <TextField
              fullWidth
              style={{marginTop:'10px'}}
              size="small"
              variant="outlined"
              InputProps={{ style: { height: "40px" } }}
              {...register("copay")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography>Type</Typography>
            <TextField
              fullWidth
              style={{marginTop:'10px'}}
              select
              variant="outlined"
              SelectProps={{ style: { height: "40px" } }}
              {...register("type")}
              value={getValues("type") || type.toLowerCase()}
              onChange={(e) => setValue("type", e.target.value)}
            >
              <MenuItem value="primary">Primary</MenuItem>
              <MenuItem value="secondary">Secondary</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </TextField>
          </Grid>
        </Grid>
        <Box
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
          }}
        >
          {/* <Button
            variant="contained"
            style={{
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "80px",
              backgroundColor: "#2B7B7E",
            }}
            onClick={() => setEligibilityOpen(true)}
          >
            Eligibility
          </Button> */}
          <Button
            variant="contained"
            style={{
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "80px",
              backgroundColor: "#2B7B7E",
            }}
            type="submit"
            onClick={handleCancelPage}
          >
            <CancelOutlinedIcon
              fontSize="medium"
              style={{ color: "red", paddingRight: "5px" }}
            />
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "80px",
              backgroundColor: "#2B7B7E",
            }}
            type="submit"
            disabled={submitting}
          >
            <SaveOutlinedIcon sx={{ color: "white", mr: 1 }} />
            Save
          </Button>
        </Box>
      </form>
    </Box>
  );
};

const InsurancePatient = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCancel = () => {
    console.log("Navigating back to patient list");
    // Replace with actual navigation logic, e.g., using react-router-dom
  };

  const patientProps = {
    patientId: 1,
    firstName: "John",
    lastName: "Doe",
    dob: "1990-01-01",
    gender: "Male",
  };

  return (
    <Grid className="page-content">
      <Container>
        <Box>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="Primary"
            textColor="#2B7B7E"
            style={{ backgroundColor: "#F5F7F9", color: "#2B7B7E" }}
          >
            <Tab label="Primary" />
            <Tab label="Secondary" />
          </Tabs>
          {tabValue === 0 && (
            <InsuranceForm
              type="Primary"
              {...patientProps}
              onCancel={handleCancel}
            />
          )}
          {tabValue === 1 && (
            <InsuranceForm
              type="Secondary"
              {...patientProps}
              onCancel={handleCancel}
            />
          )}
        </Box>
      </Container>
    </Grid>
  );
};

export default InsurancePatient;
